import Agent from './agent';

const requests = Agent.requests;

const ConfigAgent = {
  getConfig: () => requests.get(`/app-config`),
};

export default ConfigAgent;
